import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Application } from '@softline/application';
import { CommonModule } from '@angular/common';
import { UiCoreModule } from '@softline/ui-core';
import { NavigationExtras, Params } from "@angular/router";

@Component({
    selector: 'soft-app-list',
    templateUrl: './app-list.component.html',
    styleUrls: ['./app-list.component.scss'],
    imports: [CommonModule, UiCoreModule]
})
export class AppListComponent implements OnInit {
  @Input() application!: Application;
  @Output() navigate = new EventEmitter<Application>();

  constructor() {}

  ngOnInit(): void {}

  goToApplication(application: Application): void {
    this.navigate.emit(application);
  }
}
